<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="driver-acoordion">
    <div class="col-md-4 mt-12" *ngIf="DeleteAction">
      Selected: {{ SelectedNumber }}
    </div>
    <div class="dash-drivers-top1">
      <a [ngClass]="{ active: selectedDriverType == '-1' }" (click)="getDriverList('-1')">All</a>
      <a [ngClass]="{ active: selectedDriverType == 'allocated' }" (click)="getDriverList('allocated')">Allocated</a>
      <a [ngClass]="{ active: selectedDriverType == 'available' }" (click)="getDriverList('available')">Available</a>
      <a [ngClass]="{ active: selectedDriverType == 'requested' }" (click)="getDriverList('requested')">Under Verification</a>
      <a [ngClass]="{ active: selectedDriverType == 'rejected' }" (click)="getDriverList('rejected')">Rejected</a>
    </div>
    <div class="dash-drivers-top2">
      <button *ngIf="addBtn" type="button" class="button buttonBlue fixed-btn" (click)="addDriver()">
        <img class="drivers-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="selectDriver" (click)="onSelect()">
        <img class="drivers-head-img" src="../../../assets/img/check-circle.svg" />
        Select
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="cancelDriver" (click)="onSelectCancel()">
        Cancel
      </button>
      <button type="button" class="button delete-btn fixed-btn m-rl" *ngIf="deleteDriver" (click)="onDelete()">
        <img class="drivers-head-img" src="../../../assets/img/delete.svg" />
        Delete
      </button>
      <button uppercase type="button" *ngIf="searchButton" (click)="openSearch()" class="button search-btn fixed-btn">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_button">
        <input class="search pl-2" placeholder="Mobile No" id="driverNumber" maxlength="10" minlength="10"
          (input)="onInput($event)" #newItem (keyup)="onInputChange(newItem)"
          (keyup.enter)="isInputValid && search(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_Btn" class="search_icon" (click)="search(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>

        <button *ngIf="clear_Btn" class="search_number1" (click)="resetSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="drivers" *ngIf="viewDriverStatus === 0">
    <div [class.spinner]="loading"></div>

    <div class="row to_container" *ngIf="!DriverList?.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="row m-0" *ngIf="DriverList?.length && !loading">
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3 px-1" *ngFor="let item of DriverList; let i = index">
        <div class="driverscol">
          <div class="check">
            <mat-checkbox *ngIf="checkBox" (change)="matItem($event, item._id, i)"></mat-checkbox>
            <p class="driver-details">Driver ID: {{ item.driver_id }}</p>

            <div class="otp-field" *ngIf="item.driver_status === 'rejected'">
              <img src="../../../assets/img/tick-verify-red.svg" class="driver_icon" />
            </div>
            <!-- <div class="otp-field" *ngIf="item.driver_status === 'rejected'">
              <img
                src="../../../assets/img/tick-verify-red.svg"
                class="driver_icon"
              />
            </div> -->
            <div class="otp-field" *ngIf="
                item.driver_status === 'available' ||
                item.driver_status === 'approve'
              ">
              <img src="../../../assets/img/tick-verify.svg" class="driver_icon" />
            </div>
            <div class="otp-field" *ngIf="item.driver_status === 'allocated'">
              <img class="driver_icon" src="../../../assets/img/tick-verify-green.svg" alt="" />
            </div>
            <img src="{{ item.profile_image }}" (error)="item.profile_image = '../../../assets/img/defaultDP.png'"
              class="driverImg" />
          </div>
          <p class="driver-details">Driver Name: {{ item.username }}</p>
          <p class="driver-details">Contact Number: {{ item.mobile }}</p>
          <p class="driver-details">
            Assigned Truck: {{ item.truckInfo?.truck_number ?? 'NA' }}
          </p>
          <p class="driver-details">
            Recent Trip: {{ item.tripBookingInfo?.trip_id ? item.tripBookingInfo.trip_id + ' - ' +
            item.tripBookingInfo.trip_status : 'NA' }}
          </p>
          <p class="driver-details">
            Added Date: {{ item.createdAt | date : "dd-MM-yyyy" }}
          </p>
          <a class="driver-add" (click)="addNotes(item._id)">Add Notes</a>
          <a class="driver-view" (click)="viewDriver(item)">View</a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="DriverList.length > 0 && last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('first')">
      <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('last')">
      <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == fetch_page" (click)="pagination('1')">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>